import { Button } from "antd";
import styled from "styled-components";
import { COLORS } from "styles";

export const UpdateAddressButton = styled(Button)`
  width: 100%;
  border: 1px solid ${COLORS.GREY_DARK};
`;
